import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { tickerFormatter } from '../../utils/charts-common.js';

const BehaviourBarChart = ({
  chartData, grouping, intl, legend, startDate, endDate,
}) => (
  <ResponsiveContainer debounce={1000}>
    <BarChart
      data={chartData}
      margin={{
       top: 5, right: 30, left: 20, bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" vertical={false} />
      <XAxis dataKey="group" tickFormatter={tickerFormatter(intl)(grouping, startDate, endDate)} />
      <YAxis
        tickFormatter={Math.abs}
        label={{
              value: intl.formatMessage({ id: 'stats.charts.numberOfEvents' }),
              angle: -90,
              position: 'insideBottomLeft',
            }}
      />
      <Tooltip
        formatter={Math.abs}
        labelFormatter={tickerFormatter(intl)(grouping, startDate, endDate)}
      />
      {legend &&
        <Legend
          verticalAlign="middle"
          layout="vertical"
          align="right"
        />
      }
      <Bar dataKey="behaviour.brakings" fill="#D3D3D3" name={intl.formatMessage({ id: 'stats.behaviour.brakings' })} />
      <Bar dataKey="behaviour.accelerations" fill="#808080" name={intl.formatMessage({ id: 'stats.behaviour.accelerations' })} />
    </BarChart>
  </ResponsiveContainer>
);
BehaviourBarChart.propTypes = {
  intl: intlShape.isRequired,
  chartData: PropTypes.array.isRequired,
  grouping: PropTypes.string.isRequired,
  legend: PropTypes.bool,
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
};


export default injectIntl(BehaviourBarChart);



// WEBPACK FOOTER //
// ./src/components/Stats/BehaviourBarChart.js